// tutoriales_tut.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderServices from '../Header/HeaderServices';
import FooterServices from '../Footer/FooterServices';
import './tutoriales_tut.css';

const TutorialesTut = () => {
  const navigate = useNavigate();
  const [selectedTutorial, setSelectedTutorial] = useState(null);

  const tutoriales = [
    {
      id: 1,
      nombre: "Introducción a Arduino",
      imagen: "/images/PCB/PCB1.png",
      descripcion: "Aprende los fundamentos de Arduino",
      duracion: "2 horas",
      nivel: "Principiante",
      categoria: "Microcontroladores"
    },
    {
      id: 2,
      nombre: "Proyectos IoT Avanzados",
      imagen: "/images/PCB/PCB1.png",
      descripcion: "Crea proyectos conectados a internet y controla dispositivos remotamente.",
      duracion: "4 horas",
      nivel: "Avanzado",
      categoria: "IoT"
    },
    {
      id: 3,
      nombre: "Robótica con Sensores",
      imagen: "/images/PCB/PCB1.png",
      descripcion: "Construye robots inteligentes usando múltiples sensores.",
      duracion: "3 horas",
      nivel: "Intermedio",
      categoria: "Robótica"
    }
  ];

  const handleTutorialClick = (tutorial) => {
    setSelectedTutorial(tutorial);
  };

  const closeModal = () => {
    setSelectedTutorial(null);
  };

  const handleBackClick = () => {
    navigate('/tutorial');
  };

  return (
    <div className="tutoriales-tut-wrapper">
      <HeaderServices />

      {/* Hero Section */}
      <section className="tutoriales-tut-hero">
        <div className="tutoriales-tut-hero-container">
          {/* Botón de Regreso */}
          <button onClick={handleBackClick} className="tutoriales-tut-back-btn">
            <span className="tutoriales-tut-back-arrow">←</span>
            Volver
          </button>

          <h1 className="tutoriales-tut-hero-title">
            <span className="tutoriales-tut-hero-title-main">Tutoriales </span>
            <span className="tutoriales-tut-hero-title-accent">Volteon</span>
          </h1>
          <p className="tutoriales-tut-hero-description">
            Aprende con nuestros tutoriales paso a paso diseñados por expertos. 
            Desde proyectos básicos hasta implementaciones avanzadas, domina la electrónica práctica.
          </p>
          <div className="tutoriales-tut-hero-stats">
            <div className="tutoriales-tut-stat">
              <span className="tutoriales-tut-stat-number">Gran cantidad de tutoriales</span>
              <span className="tutoriales-tut-stat-label">Tutoriales</span>
            </div>
            <div className="tutoriales-tut-stat">
              <span className="tutoriales-tut-stat-number">Gran cantidad de estudiantes+</span>
              <span className="tutoriales-tut-stat-label">Estudiantes</span>
            </div>
          </div>
        </div>
      </section>

      {/* Tutoriales Grid */}
      <section className="tutoriales-tut-grid-section">
        <div className="tutoriales-tut-container">
          <h2 className="tutoriales-tut-section-title">
            <span className="tutoriales-tut-title-accent">Tutoriales</span> Destacados
          </h2>
          
          <div className="tutoriales-tut-grid">
            {tutoriales.map((tutorial) => (
              <div 
                key={tutorial.id} 
                className="tutoriales-tut-card"
                onClick={() => handleTutorialClick(tutorial)}
              >
                <div className="tutoriales-tut-card-image-container">
                  <img 
                    src={tutorial.imagen} 
                    alt={tutorial.nombre}
                    className="tutoriales-tut-card-image"
                  />
                  <div className="tutoriales-tut-card-badge">
                    <span className="tutoriales-tut-badge-nivel">{tutorial.nivel}</span>
                  </div>
                  <div className="tutoriales-tut-card-overlay">
                    <div className="tutoriales-tut-overlay-content">
                      <span className="tutoriales-tut-play-icon">▶</span>
                      <span className="tutoriales-tut-duration">{tutorial.duracion}</span>
                    </div>
                  </div>
                </div>
                
                <div className="tutoriales-tut-card-content">
                  <span className="tutoriales-tut-card-category">{tutorial.categoria}</span>
                  <h3 className="tutoriales-tut-card-title">{tutorial.nombre}</h3>
                  <p className="tutoriales-tut-card-description">{tutorial.descripcion}</p>
                  
                  <button 
                    className="tutoriales-tut-card-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      console.log('Ver tutorial:', tutorial.nombre);
                    }}
                  >
                    Comenzar Tutorial
                    <span className="tutoriales-tut-btn-arrow">→</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {selectedTutorial && (
        <div className="tutoriales-tut-modal" onClick={closeModal}>
          <div className="tutoriales-tut-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="tutoriales-tut-modal-close" onClick={closeModal}>×</button>
            
            <div className="tutoriales-tut-modal-grid">
              <div className="tutoriales-tut-modal-image-section">
                <img 
                  src={selectedTutorial.imagen} 
                  alt={selectedTutorial.nombre}
                  className="tutoriales-tut-modal-image"
                />
                <div className="tutoriales-tut-modal-play">
                  <span className="tutoriales-tut-modal-play-icon">▶</span>
                </div>
              </div>
              
              <div className="tutoriales-tut-modal-info">
                <div className="tutoriales-tut-modal-badges">
                  <span className="tutoriales-tut-modal-category">{selectedTutorial.categoria}</span>
                  <span className="tutoriales-tut-modal-nivel">{selectedTutorial.nivel}</span>
                </div>
                
                <h2 className="tutoriales-tut-modal-title">{selectedTutorial.nombre}</h2>
                
                <div className="tutoriales-tut-modal-meta">
                  <span className="tutoriales-tut-meta-item">
                    Duración: {selectedTutorial.duracion}
                  </span>
                  <span className="tutoriales-tut-meta-item">
                    +50 estudiantes
                  </span>

                </div>
                
                <p className="tutoriales-tut-modal-description">
                  {selectedTutorial.descripcion}
                </p>
                <p className="tutoriales-tut-modal-description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt 
                  ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.
                </p>
                
                <div className="tutoriales-tut-modal-features">
                  <h4>Lo que aprenderás:</h4>
                  <ul>
                    <li>✓ Conceptos fundamentales paso a paso</li>
                    <li>✓ Proyectos prácticos aplicados</li>
                    <li>✓ Código fuente completo incluido</li>
                    <li>✓ Certificado de finalización</li>
                  </ul>
                </div>
                
                <button className="tutoriales-tut-modal-btn">
                  Comenzar Ahora
                  <span className="tutoriales-tut-btn-arrow">→</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section className="tutoriales-tut-cta-section">
        <div className="tutoriales-tut-cta-container">
          <div className="tutoriales-tut-cta-box">
            <h2 className="tutoriales-tut-cta-title">
              ¿Quieres un tutorial personalizado?
            </h2>
            <p className="tutoriales-tut-cta-description">
              Solicita un tutorial específico para tu proyecto y lo crearemos para ti
            </p>
            <button className="tutoriales-tut-cta-button">
              Solicitar Tutorial
            </button>
          </div>
        </div>
      </section>

      <FooterServices />
    </div>
  );
};

export default TutorialesTut;